import request from "../utils/request";
import qs from "query-string"
// 投诉统计
export const getComplaintsStat = (params) => {
  return request.get(`/main/plat/v1/complains/stat`, {
    params,
  });
};

// 投诉列表
export const getComplaintsList = (params) => {
  return request.get(`/main/plat/v1/complains/lists`, {
    params,
  });
};

// 获取软件基本信息
export const getComplaintDetail = (params) => {
  return request.get(`/main/plat/v1/complains/item`, {
    params,
  });
};

// 回复
export const reply = (params) => {
  return request.post(`/main/plat/v1/complains/reply`, params);
};

// 投诉处理
export const dealingComplaint = (params) => {
  return request.post(`/main/plat/v1/complains/fin`, params);
};

// 退款
export const refund = (params) => {
  return request.post(`/main/plat/v1/orders/refund`, params);
};

// 图片上传
export const postImage = (params) => {
  return request.post(`/main/plat/v1/complains/image_upload`, qs.stringify(params), {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
    }
  });
};

// 联运 v2 列表
export const getComplaintsListV2 = (params) => {
  return request.get(`/main/plat/v2/complains/lists`, {
    params,
  });
};

// 联运 v2 详情
export const getComplaintDetailV2 = (params) => {
  return request.get(`/main/plat/v2/complains/item`, {
    params,
  });
};

// 联运 v2 回复/备忘
export const replyV2 = (params) => {
  return request.post(`/main/plat/v2/complains/reply`, params);
};

// 联运 v2 退款
export const refundV2 = (params) => {
  return request.post(`/main/plat/v2/orders/refund`, params);
};

// 统计兼容：优先 v2，回退 v1
export const getComplaintsStatCompat = async (params) => {
  try {
    return await request.get(`/main/plat/v2/complains/stat`, { params });
  } catch (_) {
    return await request.get(`/main/plat/v1/complains/stat`, { params });
  }
};

// 处理完成：联运页走 v2 fin（入参需含非空 content 等，与后端约定一致）
export const dealingComplaintCompat = (params) => {
  return request.post(`/main/plat/v2/complains/fin`, params);
};

// 备忘保存兼容：优先独立 remark 接口，回退 replyV2
export const saveComplaintMemoCompat = async (params) => {
  try {
    return await request.post(`/main/plat/v2/complains/remark`, params);
  } catch (_) {
    return await replyV2(params);
  }
};
